import Resource from '@/plugins/sdk/Resource'
import { UUID, STRING, DATETIME, ITEM } from '@/plugins/sdk/fields'
import Profile from './Profile'

export default class extends Resource {
  static name = 'model_history'

  static get fields () {
    return {
      id: new UUID(),
      resource: new STRING(),
      resource_uuid: new UUID(),
      original: new STRING(),
      modified: new STRING(),
      action: new STRING(),
      profile: new ITEM(Profile),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
